export const TabStyle = {
	fontStyle: "normal",
	fontWeight: "normal",
	fontSize: "16px",
	textTransform: "capitalize",
};

export const FileDropStyle = {
	boxSizing: "border-box",
	height: "176px",
	width: "100%",
	border: "1px dashed #00619D",
	backgroundColor: "#FFFFFF",
	margin: "27px auto 0 auto",
	display: "block",
};

export const FileDropInput = {
	width: "95px",
};

export const FileDropText = {
	height: "54px",
	width: "92px",
	color: "#8798AD",
	fontSize: "15px",
	fontWeight: 500,
	letterSpacing: 0,
	lineHeight: "18px",
	textAlign: "center",
};
export const FileDropGroup = {
	width: "92px",
	margin: "50px auto 0 auto",
	display: "block",
};

export const DisplayFile = {
	boxSizing: "border-box",
	width: "100%",
	border: "1px solid #00619D",
	backgroundColor: "#FFFFFF",
	margin: "5px auto 0 auto",
	display: "block",
};
export const DisplayFileItem = {
	width: "100%",
	height: "37px",
};

export const DisplayFilename = {
	height: "18px",
	color: "#00619D",
	fontSize: "15px",
	fontWeight: 500,
	letterSpacing: 0,
	lineHeight: "18px",
	padding: "9px 17px",
	float: "left",
};
export const DeleteFileIcon = {
	height: "24px",
	width: "24px",
	float: "right",
	margin: "6px",
	"&:hover": {
		color: "#D63649",
	},
};
